<template>
  <header id="global-header">
    <div
      class="environment"
      :class="currentEnv"
    >
      <strong>ENV:</strong> {{ currentEnv }}
    </div>
    <div
      v-if="isAuthenticated && studentExpire"
      class="notice-bar"
    >
      <p
        v-if="isGoingExpire"
        class="mb-0"
      >
        Your account is going to expire on {{ studentExpire }}. For extending your privilege your, please present your ID card at the
        information counter for the first time visiting C ASEAN SAMYAN CO-OP.
      </p>
      <p
        v-if="isExpired"
        class="mb-0"
      >
        Your account has been expired on {{ studentExpire }}. For extending your privilege your, please present your ID card at the
        information counter for the first time visiting C ASEAN SAMYAN CO-OP.
      </p>
    </div>
    <b-navbar
      id="main-nav"
      :class="{
        '-is-loggedin': isAuthenticated,
      }"
      toggleable="lg"
    >
      <b-navbar-brand href="/">
        <img
          src="/images/c-asean-samyan-co-op-logo.png"
          class="logo"
        >
        <img
          src="/images/c-asean-samyan-co-op-logo.png"
          class="logo-m"
        >
      </b-navbar-brand>
      <client-only>
        <div
          v-if="isAuthenticated"
          class="user-info-m"
          @click.prevent="goToMyProfile"
        >
          <img
            src="/images/member-header-bg.svg"
            class="bg"
          >
          <div
            class="user-info"
            :class="{
              '-with-image': myProfileImage,
            }"
          >
            <div
              v-if="myProfileImage"
              class="user-image"
              :style="{
                backgroundImage: `url('${myProfileImage}')`,
              }"
            >
              <img
                v-if="myProfileImage"
                :src="myProfileImage"
              >
            </div>
            <div class="user-warpper">
              <div class="user">
                {{ myDisplayName }}
              </div>
              <div class="user-privilege">
                {{ myPrivilegeName }}
              </div>
            </div>
            <div class="qr-code">
              <img src="/images/qrcode.svg">
            </div>
          </div>
        </div>
      </client-only>
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse
        id="nav-collapse"
        v-model="showMenu"
        is-nav
      >
        <client-only>
          <b-navbar-nav class="ml-auto">
            <b-nav-item
              href="#"
              :class="{
                current: isCurrentMenu('HOME'),
              }"
              @click.prevent="goHome"
            >
              Home
            </b-nav-item>
            <b-nav-item
              href="#"
              :class="{
                current: isCurrentMenu('EVENT'),
              }"
              @click.prevent="goEventsAndActivities"
            >
              Activities & Events
            </b-nav-item>
            <b-nav-item
              href="#"
              :class="{
                current: isCurrentMenu('EXPLORE'),
              }"
              @click.prevent="goExploreSpace"
            >
              Explore Space
            </b-nav-item>
            <b-nav-item
              href="#"
              :class="{
                current: isCurrentMenu('FACILITY'),
              }"
              @click.prevent="goFacilities"
            >
              Facilities
            </b-nav-item>
            <b-nav-item
              href="#"
              :class="{
                current: isCurrentMenu('CONTACT'),
              }"
              @click.prevent="goContact"
            >
              Contact
            </b-nav-item>
            <!-- <b-nav-item
              v-if="isAuthenticated"
              href="#"
              @click.prevent="logout"
            >
              Logout
            </b-nav-item> -->
            <b-nav-item
              v-if="!isAuthenticated"
              href="#"
              class="-with-border d-none d-lg-block -login-button"
              @click.prevent="login"
            >
              Login
            </b-nav-item>
            <b-nav-item
              v-if="!isAuthenticated"
              href="#"
              class="-with-border d-none d-lg-block -register-button"
              @click.prevent="register"
            >
              Sign up
            </b-nav-item>
            <!--<b-nav-item
              href="#"
              class="lang-switcher -with-border"
            >
              TH
            </b-nav-item>-->
            <b-nav-item
              v-if="isAuthenticated"
              href="#"
              class="profile-options"
              @click.prevent="goToMyProfile"
            >
              <img
                src="/images/member-header-bg.svg"
                class="bg"
              >
              <div
                class="user-info"
                :class="{
                  '-with-image': myProfileImage,
                }"
              >
                <div
                  v-if="myProfileImage"
                  class="user-image"
                  :style="{
                    backgroundImage: `url('${myProfileImage}')`,
                  }"
                >
                  <img
                    v-if="myProfileImage"
                    :src="myProfileImage"
                  >
                </div>
                <div class="user-warpper">
                  <div class="user">
                    {{ myDisplayName }}
                  </div>
                  <div class="user-privilege">
                    {{ myPrivilegeName }}
                  </div>
                </div>
                <div class="qr-code">
                  <img src="/images/qrcode.svg">
                </div>
              </div>
            </b-nav-item>
          </b-navbar-nav>
        </client-only>
      </b-collapse>
    </b-navbar>
    <login-modal ref="login-modal" />
    <forget-password-modal />
    <reset-password-modal ref="reset-password-modal" />
    <forgot-password-sent-modal ref="forgot-password-sent-modal" />
    <reset-password-completed-modal ref="reset-password-completed-modal" />
    <client-only>
      <div
        v-if="!isAuthenticated"
        class="member-login d-block d-flex d-lg-none flex-row justify-content-end"
      >
        <button
          type="button"
          class="button w-auto"
          @click.prevent="login"
        >
          LOGIN
        </button>
        <button
          type="button"
          class="button -orange-color w-auto"
          @click.prevent="register"
        >
          SIGN UP
        </button>
      </div>
    </client-only>
  </header>
</template>

<script>
import moment from 'moment-timezone'
import LoginModal from '~/components/modals/LoginModal.vue'
import ForgetPasswordModal from '~/components/modals/ForgetPasswordModal.vue'
import ResetPasswordModal from '~/components/modals/ResetPasswordModal.vue'
import ForgotPasswordSentModal from '~/components/modals/ForgotPasswordSentModal.vue'
import ResetPasswordCompletedModal from '~/components/modals/ResetPasswordCompletedModal.vue'

export default {
  name: 'GlobalHeaderComponent',
  components: {
    LoginModal,
    ForgetPasswordModal,
    ResetPasswordModal,
    ForgotPasswordSentModal,
    ResetPasswordCompletedModal
  },
  data () {
    return {
      showMenu: false,
      isGoingExpire: false,
      isExpired: false
    }
  },
  computed: {
    currentEnv () {
      return process.env.NODE_ENV
    },
    currentPageName () {
      return this.$store.getters['app/currentPageName']
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    myInfo () {
      return this.$store.getters['user/myInfo']
    },
    myDisplayName () {
      if (this.myInfo) {
        if (process.env.IS_MIGRATED) {
          if (this.myInfo.member_info) {
            return this.myInfo.member_info.display_name
          }
        } else {
          return this.myInfo.FullName
        }
      }
      return 'MY PROFILE'
    },
    myPrivilegeName () {
      if (this.myInfo) {
        return this.myInfo.prefer_privilege != null
          ? this.myInfo.prefer_privilege.name
          : ''
      }
      return ''
    },
    myProfileImage () {
      if (this.myInfo) {
        let uid = null
        if (process.env.IS_MIGRATED) {
          if (this.myInfo.member_info) {
            /* uid = this.myInfo.member_info.id
            const profileImage = this.myInfo.profile_image
            let profilePicPath = process.env.API_BASE_URL
            if (process.env.NODE_ENV === 'development') {
              profilePicPath = 'http://localhost:3000/pics'
            } else {
              profilePicPath = profilePicPath.replace('/api/v1', '/pics')
            }
            if (profileImage) {
              return `${profilePicPath}/${profileImage}`
            } */
            return this.myInfo.member_info.profile_image
          }
          return null
        } else {
          uid = this.myInfo.coworker.Id
          const cacheTime = moment()
            .tz(process.env.TIMEZONE)
            .format('x')
          return `https://nexudus.spaces.nexudus.com/en/coworker/getavatar/${uid}?w=200&h=200&anchor=middlecenter&cache=${cacheTime}`
        }
      }
      return null
    },
    studentExpire () {
      const vm = this
      if (this.isAuthenticated && this.myInfo && this.myInfo.member_info && this.myInfo.member_info.student_expiry_date) {
        console.log('myInfo', this.myInfo)
        const expireDate = moment(this.myInfo.member_info.student_expiry_date, 'MM/YY')
        console.log('expireDate', expireDate)

        if (expireDate.isValid()) {
          if (expireDate.endOf('month').isBefore(moment())) {
            vm.isExpired = true
            vm.isGoingExpire = false
            return this.myInfo.member_info.student_expiry_date
          } else if (expireDate.endOf('month').diff(moment(), 'days') < 30) {
            vm.isExpired = false
            vm.isGoingExpire = true
            return this.myInfo.member_info.student_expiry_date
          }
        }
        return false
      }
      return false
    }
  },
  methods: {
    isCurrentMenu (pageName) {
      return this.currentPageName === pageName
    },
    login () {
      this.showMenu = false
      this.$refs['login-modal'].openModal()
    },
    register () {
      this.showMenu = false
      this.$router.push('/register')
    },
    goHome () {
      this.$router.push('/')
    },
    goEventsAndActivities () {
      this.$router.push('/events-and-activities')
    },
    goExploreSpace () {
      this.$router.push('/explore-space')
    },
    goFacilities () {
      this.$router.push('/facilities')
    },
    goContact () {
      this.$router.push('/contact')
    },
    goToMyProfile () {
      this.showMenu = false
      // this.$router.push('/my-profile')
      this.$router.push('/landing-menu')
    },
    logout () {
      this.$store.dispatch('auth/LOGOUT').then(() => {
        this.$router.replace('/')
      })
    }
  }
}
</script>
